<template>
  <div>
    <header>
      <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
        <div class="container-fluid">
          <a class="navbar-brand" href="#">Manufacturing Multi-Organs (MM)</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <!-- Sidebar Toggle-->
          <button class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0" id="sidebarToggle" @click="sidebarToggle"><i class="fas fa-bars"></i></button>
          <div class="collapse navbar-collapse" id="navbarCollapse">
            <ul class="navbar-nav me-auto mb-2 mb-auto">
              <li class="nav-item">
                <a class="nav-link" aria-current="page" @click="routePush('/')">Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/organs')">Organs</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/models')">Models</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" @click="routePush('/materials')">Materials</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="https://gulab.info/about/">About</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="routePush('/visitors')">Visitors</a>
              </li>
            </ul>
            <form class="d-flex">
              <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
              <button class="btn btn-outline-light" onmouseover="this.style.backgroundColor='black';" onmouseout="this.style.backgroundColor='';"
                      type="submit" style="color:white">Search</button>
            </form>
          </div>
        </div>
      </nav>
    </header>

    <div class="sb-nav-fixed">

      <div id="layoutSidenav">
        <div id="layoutSidenav_nav" style="z-index: 3">
          <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
            <div class="sb-sidenav-menu">
              <div class="nav">
                <div class="sb-sidenav-menu-heading">Statistics</div>
                <a class="nav-link active" @click="routePush('/materials')">
                  <div class="sb-nav-link-icon"><i class="fas fa-chart-pie"></i></div>
                  Components
                </a>
                <a class="nav-link collapsed" @click="routePush('/patents')" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                  <div class="sb-nav-link-icon"><i class="fas fa-chart-area"></i></div>
                  Patents
                </a>
                <a class="nav-link collapsed" @click="routePush('/pantentComponents')" data-bs-toggle="collapse" data-bs-target="#collapseLayouts" aria-expanded="false" aria-controls="collapseLayouts">
                  <div class="sb-nav-link-icon"><i class="fas fa-chart-bar"></i></div>
                  Pantent Components
                </a>
              </div>
            </div>

          </nav>
        </div>
        <div id="layoutSidenav_content" style="margin-top:3%">
          <main>
            <div class="container-fluid px-4">

              <form class="row g-3 needs-validation" novalidate onsubmit="return false" style="margin: 0">
                <div class="col-6">
                  <label class="form-label"><strong><span style="color:darkblue">Biomaterials:</span></strong></label>
                  <el-select v-model="valueType" placeholder="Choose..." size="small" @change="handleSecTopicType()" style="width: calc(100% - 110px)">
                    <el-option
                      v-for="item in optionsType"
                      :key="item.type"
                      :label="item.type"
                      :value="item.type">
                    </el-option>
                  </el-select>
                </div>
                <div class="col-6">
                  <el-select v-model="value" placeholder="Choose..." size="small" @change="handleSecTopic()" style="width: 100%">
                    <el-option
                      v-for="item in options"
                      :key="item.id"
                      :label="item.biomaterial"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </form>
              <div class="row" style="margin-top: 20px;clear: both">
                <div class="col-lg-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-bar me-1"></i>
                      Statistic of cells
                    </div>
                    <div class="card-body"><div id="cells" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-pie me-1"></i>
                      Statistic of manufacturing method
                    </div>
                    <div class="card-body"><div id="Pie" style="width:100%; height:400px"></div></div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <i class="fas fa-line-chart me-1"></i>
                  Statistic of Organ/ structure
                </div>
                <div class="card-body"><div id="Organ">
                  <ul class="ivu-timeline">
                    <li v-for="(item,inx) in newOrganStructureList" :key="inx" class="ivu-timeline-item">
                      <div class="ivu-timeline-item-tail"></div>
                      <div class="ivu-timeline-item-head ivu-timeline-item-head-blue"></div>
                      <div class="ivu-timeline-item-content" :class="!(inx%2)?'ivu-timeline-item-content-bottom':'ivu-timeline-item-content-top'">
                        <p class="time">{{ item.year }}</p>
                        <div>
                          <div class="container-wrap" @click.stop="handleClick(item)" v-for="(row,i) in item.subList" :key="i">
<!--                            <div class="title ellipsis2"><span v-html="row.zh_title"></span></div>-->
                            <div class="container ellipsis2"><img src="../../assets/images/icon1.png" width="20"/> authors：<span v-html="row.authors"></span></div>
                            <div class="container ellipsis2"><img src="../../assets/images/icon3.png" width="20"/>organ：<span v-html="row.organ"></span></div>
                            <div class="container ellipsis2"><img src="../../assets/images/icon2.png" width="20"/>structure：<span v-html="row.structure"></span></div>
                            <div class="container ellipsis2"><img src="../../assets/images/icon7.png" width="20"/>org：<span v-html="row.org_name"></span></div>
                            <div class="container ellipsis2">doi：<a :href="'https://doi.org/'+row.doi" target="_blank">{{ row.doi}}</a></div>
<!--                            <div class="container ellipsis2">month：<span>{{ Number(row.month) }}</span></div>-->
<!--                            <div class="container ellipsis2"><img src="../assets/images/icon4.png" width="20"/>journal：<span v-html="row.journal"></span></div>-->
                          </div>
                        </div>

                      </div>
                    </li>
                  </ul>

                  <div v-if="newOrganStructureList.length===0" class="NoData">
                    No Data
                  </div>
                </div></div>
              </div>
              <div class="row">
                <div class="col-xl-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-bar-chart me-1"></i>
                      Statistic of modification
                    </div>
                    <div class="card-body"><div id="modification" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-bar me-1"></i>
                      Statistic of crosslinker
                    </div>
                    <div class="card-body"><div id="crosslinker" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xl-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-bar me-1"></i>
                      Statistic of institute
                    </div>
                    <div class="card-body"><div id="institute" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-bar me-1"></i>
                      Statistic of author
                    </div>
                    <div class="card-body"><div id="author" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-xl-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-pie me-1"></i>
                      Statistic of country
                    </div>
                    <div class="card-body"><div id="country" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="card mb-4">
                    <div class="card-header">
                      <i class="fas fa-chart-bar me-1"></i>
                      Statistic of Journal
                    </div>
                    <div class="card-body"><div id="Journal" style="width:100%;height:400px"></div></div>
                  </div>
                </div>
              </div>

              <div class="card mb-4">
                <div class="card-header">
                  <i class="fas fa-chart-area me-1"></i>
                  Statistic of knowledge graph
                </div>
                <div class="card-body">
                  <materials
                    :data="graphData">
                  </materials>
                </div>
              </div>

              <div class="card mb-4">
                <div class="card-header">
                  <i class="fas fa-table me-1"></i>
                  Related Papers
                </div>
                <div class="card-body">
                  <el-table
                    :data="tableData"
                    stripe
                    :border="false"
                    :default-sort = "{prop: 'date', order: 'descending'}"
                    style="width: 100%">
                    <el-table-column
                      prop="zh_title"
                      sortable
                      label="Title">
                    </el-table-column>
                    <el-table-column
                      prop="authors"
                      sortable
                      label="Author(s)">
                    </el-table-column>
                    <el-table-column
                      prop="year"
                      sortable
                      label="Year"
                      width="100">
                    </el-table-column>
                  </el-table>

                  <div style="text-align: end;position: relative;margin-top: 20px">
                    <el-pagination
                      background
                      @current-change="handleCurrentChange"
                      :current-page="currentPage"
                      :page-size="limit"
                      layout="prev, pager, next, jumper"
                      :total="total">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </main>
          <footer class="py-4 bg-light mt-auto">
            <div class="container-fluid px-4">
              <div class="d-flex align-items-center justify-content-between small">
                <div class="text-muted">Copyright &copy; Group of Bioinspired Engineering 2023</div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>



    <el-dialog
      title=" Statistic of Organ/ structure"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">

      <div class="dialog-container-wrap">
<!--        <div class="title"><span v-html="organ_structure.zh_title"></span></div>-->
        <div class="container"><img src="../../assets/images/icon1.png" width="20"/> authors：<span v-html="organ_structure.authors"></span></div>
        <div class="container"><img src="../../assets/images/icon3.png" width="20"/>organ：<span v-html="organ_structure.organ"></span></div>
        <div class="container"><img src="../../assets/images/icon2.png" width="20"/>structure：<span v-html="organ_structure.structure"></span></div>
<!--        <div class="container"><img src="../assets/images/icon4.png" width="20"/>journal：<span v-html="organ_structure.journal"></span></div>-->
        <div class="container ellipsis2"><img src="../../assets/images/icon7.png" width="20"/>org：<span v-html="organ_structure.org_name"></span></div>
        <div class="container ellipsis2">doi：<a :href="'https://doi.org/'+organ_structure.doi" target="_blank">{{ organ_structure.doi}}</a></div>
<!--        <div class="container ellipsis2">month：<span>{{ Number(organ_structure.month) }}</span></div>-->

        <div class="container"><img src="../../assets/images/icon5.png" width="20"/>year：<span v-html="organ_structure.year"></span></div>
      </div>


    </el-dialog>
  </div>
</template>

<script>
// import '../../assets/js/jquery-3.6.0.min.js'
// import '../../assets/js/bootstrap.bundle.min.js'
import * as echarts from "echarts";
import materials from './modules/graphChar'

import {
  getBiomaterialList,
  getCellList,
  getModificationList,
  getManufacturingMethodList,
  getCrosslinkerList,
  getInstituteList,
  getAuthorList,
  getCountryList,
  getJournalList,
  getOrganStructureList,
  getRelatedPaper,
  getNetworkTree

} from "@/request/materials";
export default {
  name: 'index',
  data(){
    return{
      organ: '',
      tableData: [],
      limit: 10,
      currentPage: 1,
      total: 0,
      value: '',
      valueType: 'Synthetic',
      optionsType: [],
      options: [],
      graphData: {},
      organStructureList: [],
      newOrganStructureList: [],
      dialogVisible: false,
      organ_structure: {
        // zh_title: '',
        authors: '',
        organ: '',
        structure: '',
        // journal: '',
        year: '',
        org_name: '',
        doi: '',
        month: '',

      }

    }
  },
  components:{
    materials
  },
  mounted () {
    this.getBiomaterial('');
  },
  methods:{

    axiosAll(){
      // Interface Connection
      let parameter = { biomaterial: this.value };

      // Pie Chart
      getManufacturingMethodList(parameter).then(res => {
        const data= res.map((item)=>{
          item.name= item.manufacturing_method;
          item.value= item.count;
          return item;
        });

        let ctx = echarts.init(document.getElementById('Pie'));
        let option = {
          tooltip: {
            trigger: 'item'
          },
          legend: {
            // top: '5%',
            // left: 'center'
            orient: 'vertical',
            right: 'right',
            // bottom: 0
            // selectedMode:false
          },
          series: [
            {
              type: 'pie',
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: true,
                formatter: '{b}: {@2012} ({d}%)'
              },
              labelLine: {
                show: true
              },
              data: data
            }
          ]
        };
        ctx.setOption(option);
      });
    },

    searchList(){
      let parameter = { page:this.currentPage, biomaterial: this.value };
      getRelatedPaper(parameter).then(res => {
        this.tableData= [];
        this.tableData= res;
        this.total= res.length;
      });
    },


    getBiomaterial(val){
      getBiomaterialList('').then(res => {
        this.optionsType= res;
        let newArr= res.filter((item)=>{
            return this.valueType===item.type;
        });
        this.options= newArr[0].child;

        // this.value= '68a1f3efed89284b9c0e4b136edefc80';
        this.value= 'a88ca80486e19685b17923e03b3bedb8';
        this.axiosAll();
        this.searchList();
        this.getCell('');
        this.getCrosslinker('');
        this.getAuthor('');
        this.getJournal('');
        this.getNetworkTree('');
        this.getOrganStructure('');
        this.getCountry('');
        this.getInstitution('');
        this.getInstitute('');
      });
    },

    getCell(val){
      let param={ biomaterial: this.value };

      getCellList(param).then(res => {
        const data= res.filter((item,inx)=>{
          item.name= item.cell;
          item.value= item.count;
          if (inx<=9)
            return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [0, 10, 10, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#0663dbb3' },
              { offset: 0.2, color: '#0663dbb3' },
              { offset: 1, color: '#0663db' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'right',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData=  data.splice(0,100).reverse();
        let ctx = echarts.init(document.getElementById('cells'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            // right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          xAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                // rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data:  xAxisData.splice(0,100).reverse()
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });
    },

    getCrosslinker(val){
      let param={ biomaterial: this.value };

      getCrosslinkerList(param).then(res => {
        const data= res.filter((item,inx)=>{
          item.name= item.crosslinker;
          item.value= item.count;
          if (inx<=9)
            return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [0, 10, 10, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#51d8e7' },
              { offset: 0.2, color: '#2cbccc' },
              { offset: 1, color: '#16a5b4' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'right',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData=  data.splice(0,100).reverse();
        let ctx = echarts.init(document.getElementById('crosslinker'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            // right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          xAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                // rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data:  xAxisData.splice(0,100).reverse()
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });
    },

    getAuthor(val){
      let param={ biomaterial: this.value };

      getAuthorList(param).then(res => {
        const data= res.filter((item,inx)=>{
          item.name= item.author_name;
          item.value= item.count;
          if (inx<=9)
            return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [0, 10, 10, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#ffac21b3' },
              { offset: 0.2, color: '#ffac21b3' },
              { offset: 1, color: '#ffac21' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'right',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData=  data.splice(0,100).reverse();
        let ctx = echarts.init(document.getElementById('author'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            // right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          xAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                // rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data:  xAxisData.splice(0,100).reverse()
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });
    },

    getJournal(val){
      let param={ biomaterial: this.value };

      getJournalList(param).then(res => {
        const data= res.filter((item,inx)=>{
          item.name= item.journal;
          item.value= item.count;
          if (inx<=9)
            return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [0, 10, 10, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#3f60c8b3' },
              { offset: 0.2, color: '#3f60c8b3' },
              { offset: 1, color: '#3f60c8' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'right',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData=  data.splice(0,100).reverse();
        let ctx = echarts.init(document.getElementById('Journal'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            // right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          xAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                // rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data:  xAxisData.splice(0,100).reverse()
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });
    },

    getNetworkTree(val){
      let param={ id: this.value };
      getNetworkTree(param).then(res => {
        this.graphData= res;
      });
    },

    getOrganStructure(val){
      let param={ biomaterial: this.value };

      getOrganStructureList(param).then(res => {
        this.organStructureList= res;
        let data= JSON.parse(JSON.stringify(res));
        let newArr = [];
        data.forEach((item, i) => {
          let index = -1;
          let isExists = newArr.some((newItem, j) => {
            if (item.year == newItem.year) {
              index = j;
              return true;
            }
          });
          if (!isExists) {
            newArr.push({
              year: item.year,
              subList: [item]
            });
          } else {
            newArr[index].subList.push(item);
          }
        });
        this.newOrganStructureList= newArr;













        // let organList= [], structureList= [];
        // res.forEach((item,inx)=>{
        //   if (inx<=9){
        //     organList.push(Number(item.organ));
        //     structureList.push(Number(item.structure));
        //   }
        // });
        // let xAxisData = res.map((item)=>{ return item.year});
        // let ctx = echarts.init(document.getElementById('Organ'));
        // let option  = {
        //   tooltip: {
        //     trigger: 'axis'
        //   },
        //   legend: {
        //     data: ['Organ', 'Structure']
        //   },
        //   grid: {
        //     left: '3%',
        //     right: '4%',
        //     bottom: '3%',
        //     containLabel: true
        //   },
        //   xAxis: {
        //     type: 'category',
        //     boundaryGap: false,
        //     data: xAxisData.splice(0,100).reverse()
        //   },
        //   yAxis: {
        //     type: 'value'
        //   },
        //   series: [
        //     {
        //       name: 'Organ',
        //       type: 'line',
        //       stack: 'Total',
        //       data: organList
        //     },
        //     {
        //       name: 'Structure',
        //       type: 'line',
        //       stack: 'Total',
        //       data: structureList
        //     }
        //   ]
        // };
        // ctx.setOption(option);
      });
    },

    getCountry(val){
      let param={ biomaterial: this.value };

      getCountryList(param).then(res => {
        const data= res.filter((item,inx)=>{
          item.name= item.country;
          item.value= item.count;
          if (inx<=9)
            return item;
        });

        let seriesData=  data;
        let ctx = echarts.init(document.getElementById('country'));
        let option  = {
          color: [
            '#6AA0FF',
            // '#0077FC',
            // '#3B53AD',
            '#10C2D1',
            // '#00ED9C',
            '#FFC833',
            '#FFAC22',
            '#FBDC80',
            '#2738A2',
            '#10C2D1',
            '#0044F4',
            '#0095FD',
            '#00B3FF',
            '#00E1F4',
            '#00ED9C',
            '#00FF9F',
            '#FFC833',
            '#FFAC22',
            '#FBDC80',
            '#FFD600',
            '#4F80FF',
            '#D9E7FF',
            '#3E60C8',
          ],
          tooltip: {
            trigger: 'item'
          },
          legend: {
            // top: '5%',
            // left: 'center'
            orient: 'vertical',
            right: 'right',
            // bottom: 0
            // selectedMode:false
          },
          series: [
            {
              type: 'pie',
              avoidLabelOverlap: false,
              // roseType: 'area',
              // radius: [20, '80%'],
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: true,
                formatter: '{b}: {@2012} ({d}%)'
              },
              labelLine: {
                show: true
              },
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });
    },

    getInstitution(val){
      let param={ biomaterial: this.value};
      getModificationList(param).then(res => {
        const data= res.filter((item,inx)=>{
          item.name= item.modification;
          item.value= item.count;
          if (inx<=9)
            return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [10, 10, 0, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#788de0b3' },
              { offset: 0.2, color: '#788de0b3' },
              { offset: 1, color: '#788de0' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'top',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData= data;
        let ctx = echarts.init(document.getElementById('modification'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data: xAxisData.splice(0,100)
            }
          ],
          yAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });

    },

    getInstitute(val){
      let param={ biomaterial: this.value};
      getInstituteList(param).then(res => {
        const data= res.filter((item,inx)=>{
          item.name= item.organization;
          item.value= item.count;
          if (inx<=9)
            return item;
        });
        data.forEach((item,index)=>{
          item.itemStyle={
            barBorderRadius: [0, 10, 10, 0],
            // color: this.color[index%this.color.length],
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#01ec9db3' },
              { offset: 0.2, color: '#01ec9db3' },
              { offset: 1, color: '#01ec9d' }
            ])
          };
          item.label= {
            show: true,
            color: '#8f949f',
            position: 'right',
            valueAnimation: true
          }
        });
        let xAxisData = data.map((item)=>{ return item.name});
        let seriesData= data.splice(0,100).reverse();
        let ctx = echarts.init(document.getElementById('institute'));
        let option  = {
          tooltip: {},
          grid : {
            left: 0,
            // right : 0,
            bottom : 0,
            top : 10,
            containLabel : true
          },
          xAxis: [
            {
              name: '',
              type: 'value',
              nameTextStyle:{
                color:'#262626'
              },
              axisTick: {show: false},
              axisLine: {
                show: false,
                lineStyle:{
                  color:'#ededed'
                }
              },
              splitLine:{
                show: true,
                lineStyle:{
                  color:'#ededed'
                }},
              axisLabel:{
                color:'#6F6F6F',
              },
            }
          ],
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: {
                show: true,
                lineStyle:{
                  color:'#979797'
                }
              },
              axisLabel:{
                color:'#6F6F6F',
                interval: 0,
                // rotate: 45,
                formatter: function(params) {
                  var newParamsName = "";
                  var paramsNameNumber = params.length;
                  var provideNumber = 20;
                  if (paramsNameNumber > provideNumber) {
                    newParamsName= params.substr(0,provideNumber)+'...';
                  } else {
                    newParamsName = params;
                  }
                  return newParamsName;
                }
              },
              data: xAxisData.splice(0,100).reverse()
            }
          ],
          series: [
            {
              type: 'bar',
              barGap: 0,  //两个柱状之间的间隙
              barWidth :25, //柱形的宽度
              data: seriesData
            }
          ]
        };
        ctx.setOption(option);
      });

    },

    GetOrgan(name) {
      let  reg = new  RegExp( "(^|&)" + name + "=([^&]*)(&|$)" );
      let  r = window.location.search.substr(1).match(reg);
      if (r!= null ) return   unescape(r[2]); return  null ;
    },

    handleSecTopicType(){
      let newArr= this.optionsType.filter((item)=>{
        return this.valueType===item.type;
      });
      this.options= newArr[0].child;
      this.value= '';

    },

    handleSecTopic(){
      this.axiosAll();
      this.searchList();
      this.getCell('');
      this.getCrosslinker('');
      this.getAuthor('');
      this.getJournal('');
      this.getNetworkTree('');
      this.getOrganStructure('');
      this.getCountry('');
      this.getInstitution('');
      this.getInstitute('');
    },

    handleCurrentChange(val) {
      this.currentPage= val;
      this.searchList();
    },

    sidebarToggle(){
      document.body.classList.toggle('sb-sidenav-toggled');
      localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sb-sidenav-toggled'));
    },

    routePush(path){
      this.$router.push({ path:path })
    },


    handleClose(done) {
      done();
    },
    handleClick(row) {
      // this.dialogVisible= true;
      // this.organ_structure= row;
    },

  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/styles.css";
@import "../../assets/css/bootstrap.min.css";

.bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}

@media (min-width: 768px) {
  .bd-placeholder-img-lg {
    font-size: 3.5rem;
  }
}

#Organ{
  width:100%;
  height:500px;
  overflow: auto;
  position: relative;
}
.ivu-timeline {
  list-style: none;
  margin: 0;
  padding: 0;
  height: 100%;
  width: max-content;
  .ivu-timeline-item{
    margin: 0!important;
    padding: 0 0 12px;
    list-style: none;
    position: relative;
    float: left;
    min-width: 300px;
    max-width: 400px;
    height: 100%;
    .ivu-timeline-item-tail {
      //height: 100%;
      border-top: 3px solid #d9d9d9;
      position: absolute;
      left: 10px;
      top: 50%;
      width: 100%;
    }
    .ivu-timeline-item-head {
      width: 13px;
      height: 13px;
      background-color: #fff;
      border-radius: 50%;
      border: 2px solid transparent;
      position: absolute;
      left: 10px;
      top: calc(50% - 6px);
    }
    .ivu-timeline-item-head-blue {
      border-color: #2d8cf0;
      color: #2d8cf0;
    }
    .ivu-timeline-item-content {
      font-size: 14px;
      position: relative;
      display: grid;
      height: 50%;
      .time {
        font-size: 14px;
        font-weight: 700;
        margin: 0;
        color: #2d8cf0;


      }
      div+div{
        margin-top: 8px;
      }
      //.title{
      //  font-weight: 500;
      //  color: #262626;
      //  font-size: 16px;
      //  word-wrap: break-word;
      //  word-break: break-all;
      //  padding: 0;
      //}
      .container-wrap{
        background: #f9f8f8;
        border-radius: 10px;
        padding: 10px 6px;
        border: 1px dashed #cfcdcd;
        &:hover{
          background: #fffcf1;
          cursor: pointer;
          border-color: #b4c52c;
        }
      }
      .container{
        font-size: 12px;
        color: #757575;
        position: relative;
        padding: 0 0 0 26px;
        span{
          color: rgb(48, 48, 48);
          font-size: 14px;
          word-wrap: break-word;
          word-break: break-all;
        }
        img{
          position: absolute;
          left: 0;
        }
      }
    }


    .ivu-timeline-item-content-top{
      //position: absolute;
      //top: 48%;
      padding: 0 0 20px 0;
      .time{
        position: absolute;
        bottom: 0;
      }
    }

    .ivu-timeline-item-content-bottom{
      top: 50%;
      padding: 10px 0 0 0 ;
    }
  }

  .ivu-timeline-item:last-child .ivu-timeline-item-tail {
    display: none;
  }
}
.dialog-container-wrap{
  background: #f9f8f8;
  border-radius: 10px;
  padding: 10px 6px;
  border: 1px dashed #cfcdcd;
  div+div{
    margin-top: 8px;
  }
  //.title{
  //  font-weight: 500;
  //  color: #262626;
  //  font-size: 16px;
  //  word-wrap: break-word;
  //  word-break: break-all;
  //  padding: 0;
  //}
  .container{
    font-size: 12px;
    color: #757575;
    position: relative;
    padding: 0 0 0 26px;
    span{
      color: rgb(48, 48, 48);
      font-size: 14px;
      word-wrap: break-word;
      word-break: break-all;
    }
    img{
      position: absolute;
      left: 0;
    }
  }
}
.NoData{
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: center;
  line-height: 500px;
  color: #909399;
}
</style>



// WEBPACK FOOTER //
// src/pages/materials/index.vue